import { get, put, post } from 'api/request';
import urls from 'configs/urls';

export const getMembers = queryString =>
  get(null, false, `${urls.membersUrls.getusers}?${queryString}`);

export const blockMember = queryString =>
  put(null, false, `${urls.membersUrls.blockUser}?${queryString}`);

export const getMemberTransactions = params =>
  post(null, false, `${urls.membersUrls.getUserTransactions}`, params);

export const awardPoints = params => post(null, false, `${urls.membersUrls.awardPoints}`, params);

export const deductPoints = params => post(null, false, `${urls.membersUrls.deductPoints}`, params);
